import styled from 'styled-components';
import { media } from 'legacyComponents/styled/styleUtils';
import { Indicator } from 'legacyComponents/styled/lib';

export const Wrapper = styled.nav`
  ${media.xs`
    display: none;
  `};
`;

export const Stat = styled.div`
  display: inline-block;
  opacity: ${props => (props.disabled ? 0.5 : 1)};
  transition: all 100ms ease-in-out;
  color: ${props => props.theme.color.wfGrey900};
  border-radius: ${props => props.theme.borderRadius.large};
  border: 1px solid ${props => props.theme.color.wfGrey700};
  margin-top: 1.25rem;
  & + & {
    margin-left: ${props => props.theme.spacing.default};
  }
  ${props =>
    !props.disabled &&
    `
    &:hover {
      cursor: pointer;
      color: ${props.theme.color.wfBlue};
      border-color: currentColor;
      > p {
        border-left-color: currentColor;
      }
    }
    `}
`;

export const Button = styled.button`
  display: inline-block;
  border: none;
  font-size: ${props => props.theme.font.size.small};
  color: inherit;
  background-color: transparent;
  border-radius: ${props =>
    `${props.theme.borderRadius.large} 0 0 ${props.theme.borderRadius.large}`};
  padding: ${props =>
    `${props.theme.spacing.xsmall} ${props.theme.spacing.default}`};
  &:hover {
    cursor: pointer;
  }
`;

export const Count = styled.p`
  display: inline-block;
  font-size: ${props => props.theme.font.size.small};
  color: inherit;
  border-radius: ${props =>
    `0 ${props.theme.borderRadius.large} ${props.theme.borderRadius.large} 0`};
  padding: ${props =>
    `${props.theme.spacing.xsmall} ${props.theme.spacing.small}`};
  border-left: 1px solid ${props => props.theme.color.wfGrey300};
  transition: all 100ms ease-in-out;
`;

export const IndicatorStyled = styled(Indicator)`
  height: 22px;
  width: 70px;
  display: inline-block;
  margin-left: ${props => props.theme.spacing.default};
`;
